import api from "@/api";
import { horasDaLive } from "@/utils/horasDaLive";

/**
 * Horas de acesso à live por plano, do admin ("Tempo de acesso"), para a lista de
 * benefícios dos planos. Vários componentes chamam ao mesmo tempo (um por card de
 * plano), então a busca é uma só: `defer` reaproveita o pedido em andamento, e o
 * resultado fica no payload (do SSR ou da primeira busca no navegador) para as
 * próximas páginas. Se a API falhar, valem 48 e 72 (utils/horasDaLive.ts).
 *
 * `semRedirect404`: sem ele, um 404 (ex.: o Nuxt no ar antes do backend com a rota)
 * faria o interceptor mandar quem está no /assine para a home.
 */
export function useHorasDaLive() {
  const { data } = useAsyncData(
    "horas-da-live",
    () =>
      api
        .get("v1/live/getAccessHours", { semRedirect404: true })
        .then(({ data }) => data)
        .catch(() => null),
    {
      dedupe: "defer",
      getCachedData: (chave, nuxtApp) =>
        nuxtApp.payload.data[chave] ?? nuxtApp.static.data[chave],
    }
  );

  return computed(() => horasDaLive(data.value));
}
